import React, { Component } from "react";
import { Map, GoogleApiWrapper, Marker } from "google-maps-react";
import InfoWindowEx from "../InfoWindowEx/InfoWindowEx";
import Markers from "../Marker/Markers";
import RestaurantDetail from "../RestaurantDetail/RestaurantDetail";
import MARKER_ICON from "../../const/corona-bottle.png";
import { connect } from "react-redux";

export class GoogleMap extends Component {
  constructor(props) {
    super(props);

    this.onMarkerMounted = element => {
      this.setState(prevState => ({
        markerObjects: [...prevState.markerObjects, element.marker]
      }));
    };

    this.state = {
      center: null,
      showingInfoWindow: false,
      activeMarker: null,
      selectedRestaurant: null,
      markerObjects: []
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.innerWidth < 768) {
      this.directionsActive = false;
    }
    if (this.props.innerWidth < 768 && this.props.destination === null) {
      this.directionsRenderer.setDirections({ routes: [] });
    }

    if (
      !this.directionsActive &&
      this.props.origin !== null &&
      this.props.destination !== null
    ) {
      // console.log(
      //   "selectedRestaurant ==>>>>>>>>> ",
      //   this.state.selectedRestaurant
      // );
      this.calculateAndDisplayRoute(
        this.directionsService,
        this.directionsRenderer
      );
      this.directionsActive = true;
      this.onInfoWindowClose();
    }
  }

  componentWillUpdate() {
    // console.log("componentWillUpdate ==>>>", this.center);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.selectedLocation) {
      // console.log("nextProps.selectedLocation", nextProps.selectedLocation);
      this.selectedLocation = nextProps.selectedLocation;
      if (this.onePass) {
        this.setState({ center: this.selectedLocation });
        this.onePass = false;
      }
    }

    if (nextProps.selectedRestaurantId) {
      if (this.onePass) {
        this.onLiClick(nextProps.selectedRestaurantId);
        this.onePass = false;
      }
    }

    if (
      this.props.origin === nextProps.origin &&
      this.props.destination === nextProps.destination &&
      this.state.showingInfoWindow === nextState.showingInfoWindow &&
      this.state.activeMarker === nextState.activeMarker &&
      this.state.selectedRestaurant === nextState.selectedRestaurant &&
      this.state.getSelectedRestaurantId ===
        nextState.getSelectedRestaurantId &&
      this.state.center === nextState.center
    ) {
      // console.log("shouldComponentUpdate ==>>> NO");
      return false;
    }

    // console.log("shouldComponentUpdate ==>>> YES");
    return true;
  }

  componentDidMount() {
    this.landing = true;
    this.directionsActive = false;
    this.onePass = true;
  }

  calculateAndDisplayRoute(
    directionsService: google.maps.DirectionsService,
    directionsRenderer: google.maps.DirectionsRenderer
  ) {
    if (this.props.origin !== null && this.props.destination !== null) {
      directionsService.route(
        {
          origin: this.props.origin,
          destination: this.props.destination,
          travelMode: "DRIVING"
        },
        (response, status) => {
          if (status == "OK") {
            directionsRenderer.setDirections(response);
          } else {
            window.alert("Directions request failed due to " + status);
          }
        }
      );
    }
  }

  _mapLoaded(mapProps, map) {
    // console.log("_mapLoaded ==>>");

    this.state.markerObjects.forEach((item, i) => {
      item.setMap(map);
    });

    // map.setCenter({ lat: 47, lng: -75 });

    // this.onMarkerClick(this.refs.)

    const google = this.props.google;

    const directionsRenderer = new google.maps.DirectionsRenderer({
      polylineOptions: {
        strokeColor: "#fec136"
      },
      suppressMarkers: true
    });
    const directionsService = new google.maps.DirectionsService();

    this.directionsRenderer = directionsRenderer;
    this.directionsService = directionsService;

    directionsRenderer.setMap(map);

    google.maps.event.addListener(map, "idle", event => {
      // console.log("idle listener ==>>>");
      const bounds = map.getBounds();
      const keys = Object.keys(bounds);
      const latkeys = Object.keys(bounds[keys[0]]);
      const lngkeys = Object.keys(bounds[keys[1]]);
      const center = {
        lat: (bounds[keys[0]][latkeys[0]] + bounds[keys[0]][latkeys[1]]) / 2,
        lng: (bounds[keys[1]][latkeys[1]] + bounds[keys[1]][latkeys[1]]) / 2
      };

      this.center = center;

      if (this.selectedLocation && this.selectedLocation !== this.center) {
        // console.log(this.selectedLocation);
        this.props.resetSelectedLocation();
        this.selectedLocation = null;
        this.onInfoWindowClose();
        this.onePass = true;
      }

      if (this.selectedRestaurantId && this.selectedLocation !== this.center) {
        // console.log(this.selectedLocation);
        this.props.resetSelectedLocation();
        this.selectedLocation = null;
        this.onePass = true;
      }

      if (this.landing) {
        this.landing = false;

        const tier1RestaurantListings = this.props.restaurantListings.filter(
          restaurant => {
            return (
              restaurant.tierLevel === "Tier 1" ||
              restaurant.tierLevel === "Tier 1 (User Paid)"
            );
          }
        );

        for (var i = 0; i < tier1RestaurantListings.length; i++) {
          tier1RestaurantListings[i]["distance"] = this.calculateDistance(
            center.lat,
            center.lng,
            tier1RestaurantListings[i]["latitude"],
            tier1RestaurantListings[i]["longitude"],
            "K"
          );
        }

        const tier1RestaurantListingsSortedByDistance = tier1RestaurantListings.sort(
          function(a, b) {
            return a.distance - b.distance;
          }
        );

        if (
          JSON.stringify(this.props.restaurantsInBounds) !==
          JSON.stringify(tier1RestaurantListingsSortedByDistance)
        ) {
          // console.log(
          //   "restaurantsInBounds changed==>>",
          //   tier1RestaurantListingsSortedByDistance,
          //   "proppp",
          //   this.props.restaurantsInBounds
          // );
          this.props.updateBounds(tier1RestaurantListingsSortedByDistance);
        }
      } else {
        // console.log("Render List ==>>>");
        const restaurantsInBounds = this.props.restaurantListings.filter(
          restaurant => {
            return map.getBounds().contains({
              lat: restaurant.latitude,
              lng: restaurant.longitude
            });
          }
        );

        if (restaurantsInBounds.length >= 5) {
          for (var i = 0; i < restaurantsInBounds.length; i++) {
            restaurantsInBounds[i]["distance"] = this.calculateDistance(
              center.lat,
              center.lng,
              restaurantsInBounds[i]["latitude"],
              restaurantsInBounds[i]["longitude"],
              "K"
            );
          }

          const restaurantsInBoundsSortedByDistance = restaurantsInBounds.sort(
            function(a, b) {
              return a.distance - b.distance;
            }
          );
          this.props.updateBounds(restaurantsInBoundsSortedByDistance);
        } else {
          for (var i = 0; i < this.props.restaurantListings.length; i++) {
            this.props.restaurantListings[i][
              "distance"
            ] = this.calculateDistance(
              center.lat,
              center.lng,
              this.props.restaurantListings[i]["latitude"],
              this.props.restaurantListings[i]["longitude"],
              "K"
            );
          }

          const restaurantListingsSortedByDistance = this.props.restaurantListings.sort(
            function(a, b) {
              return a.distance - b.distance;
            }
          );

          this.props.updateBounds(
            restaurantListingsSortedByDistance.slice(0, 5)
          );
        }
      }
    });
  }

  calculateDistance(lat1, lon1, lat2, lon2, unit) {
    var radlat1 = (Math.PI * lat1) / 180;
    var radlat2 = (Math.PI * lat2) / 180;
    var radlon1 = (Math.PI * lon1) / 180;
    var radlon2 = (Math.PI * lon2) / 180;
    var theta = lon1 - lon2;
    var radtheta = (Math.PI * theta) / 180;
    var dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == "K") {
      dist = dist * 1.609344;
    }
    if (unit == "N") {
      dist = dist * 0.8684;
    }
    return dist;
  }

  onLiClick = id => {
    // console.log("onLiClick ===========>>>>>>>>");
    const obj = this.state.markerObjects.filter(marker => {
      return marker.id === id;
    });
    const marker = obj[0];

    if (this.directionsActive) {
      this.directionsRenderer.setDirections({ routes: [] });
    }
    this.setState(
      {
        selectedRestaurant: marker.restaurant,
        activeMarker: marker,
        showingInfoWindow: true
      },
      () => {
        if (this.directionsActive) {
          this.directionsActive = false;
          this.props.resetDestination();
        }
        this.props.resetSelectedRestaurantId();
        this.onePass = true;
      }
    );
  };

  onMarkerClick = (props, marker) => {
    // console.log("MARKER CLICKED ==>>>", marker);
    if (this.directionsActive) {
      this.directionsRenderer.setDirections({ routes: [] });
    }
    this.setState(
      {
        selectedRestaurant: marker.restaurant,
        activeMarker: marker,
        showingInfoWindow: true
      },
      () => {
        if (this.directionsActive) {
          this.directionsActive = false;
          this.props.resetDestination();
        }
      }
    );
  };

  onInfoWindowClose = props => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
        selectedRestaurant: null
      });
    }
  };

  onMapClicked = props => {
    // console.log("MAP CLICKED ==>>>");
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
        selectedRestaurant: null
      });
    }
  };

  render() {
    // console.log("render of gmap-==>>>", this.state);
    return (
      <div>
        <Map
          initialCenter={this.props.initialCenter}
          center={this.state.center || this.props.center}
          google={window.google}
          styles={this.props.mapStyle}
          defaultZoom={this.props.defaultZoom}
          mapTypeControl={false}
          mapType={this.props.mapType}
          onReady={(mapProps, map) => this._mapLoaded(mapProps, map)}
          onClick={this.onMapClicked}
          origin={this.props.origin}
          destination={this.props.destination}
        >
          {this.props.children}
          {this.props.innerWidth >= 768 ? (
            <Markers
              restaurantData={this.props.restaurantListings}
              onMarkerClick={this.onMarkerClick}
              onMarkerMounted={this.onMarkerMounted}
              url={MARKER_ICON}
            />
          ) : null}
          {this.props.innerWidth >= 768 ? (
            <InfoWindowEx
              onClose={this.onInfoWindowClose}
              marker={this.state.activeMarker}
              visible={this.state.showingInfoWindow}
            >
              {this.state.selectedRestaurant ? (
                <RestaurantDetail
                  innerWidth={this.props.innerWidth}
                  openLink={this.props.openLink}
                  restaurant={this.state.selectedRestaurant}
                  setDestination={this.props.setDestination}
                />
              ) : (
                <div />
              )}
            </InfoWindowEx>
          ) : null}
        </Map>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    stats: state.stats
  };
};

const WrappedContainer = GoogleApiWrapper({
  apiKey: "AIzaSyBdTtuiGTPtv3nE31khxrOBdBg2OylWcro"
})(GoogleMap);

export default connect(
  mapStateToProps,
  null
)(WrappedContainer);
